import React, { Component } from "react";
import Voucher from "../../../components/Voucher/Voucher";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AccountingForm
Description : Compoente que alberga el resto del formulario de registro definido en el directorio de componentes
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina – Se llama al componente de Accounting con sus respectivos parámetros.
================================================================================ */

class VoucherForm extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <Voucher/>
        )
    }
}

export default VoucherForm;